import { FC } from 'react'
import styles from './styles.module.css'
import { ILoaderProps } from './ILoader'

const Loader: FC<ILoaderProps> = ({ style, type }) => {
	switch (type) {
		case 'small':
			return <div style={style} className={styles.spinner__small} />
		case 'main':
			return (
				<div style={style} className={styles.fon}>
					<div className={styles.spinner} />
				</div>
			)
		default:
			return (
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', ...style }}>
					<div className={styles.spinner} />
				</div>
			)
	}
}

export default Loader
